<template>
    <section class="distribut">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h4 class="distribut__small-title">Развернуть список</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="distribut__inner"
                         v-for="item in items"
                    >
                        <div class="distribut__container">
                            <span class="distribut__name">{{ item.name }}</span>
                            <div class="distribut__contact">
                                <div class="distribut__call copyEl">
                                    <a :href="`tel:${item.tel}`" class="link distribut__link">{{ item.tel }}</a>
                                    <span class="copyData"><svg width="32" height="32"
                                                                viewBox="0 0 32 32"
                                                                fill="none"
                                                                stroke="#C0C0C0"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z"
                                                              stroke="inherit" stroke-width="1.5" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                        <path d="M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8"
                                                              stroke="inherit" stroke-width="1.5" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                    </svg>
                                                  </span>
                                </div>
                                <div class="distribut__mail copyEl">
                                    <a :href="`mailto:${item.email}`" class="link distribut__link">{{ item.email }}</a>
                                    <span class="copyData"><svg width="32" height="32"
                                                                viewBox="0 0 32 32"
                                                                fill="none"
                                                                stroke="#C0C0C0"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z"
                                                              stroke="inherit" stroke-width="1.5" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                        <path d="M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8"
                                                              stroke="inherit" stroke-width="1.5" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                    </svg>
                                                  </span>
                                </div>
                                <div class="distribut__site copyEl">
                                    <a :href="`https://${item.website}`" class="link distribut__link"
                                       target="_blank">{{ item.website }}</a>
                                    <span class="copyData"><svg width="32" height="32"
                                                                viewBox="0 0 32 32"
                                                                fill="none"
                                                                stroke="#C0C0C0"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z"
                                                              stroke="inherit" stroke-width="1.5" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                        <path d="M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8"
                                                              stroke="inherit" stroke-width="1.5" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                    </svg>
                                                  </span>
                                </div>
                            </div>
                            <div class="distribut__data">
                                <p class="distribut__subtext">ПН-ПТ: с 09-00 до 18-00 СБ-ВС:
                                    выходной</p>
                                <p class="distribut__subtext distribut__address">{{ item.address }}</p>
                            </div>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </section>
</template>

<script>
export default {
    name: "distribut",
    props: {
        items: String | Number | Boolean | Object | Array,
    },
    data() {
        return {
            // items: [
            //     {
            //         name: 'ООО ТД Циркон',
            //         tel: '+7 (831) 268-16-00',
            //         email: 'info@packnn.ru',
            //         website: 'packnn.ru',
            //         address: '603003 г. Нижний Новгород, ул. Свободы, д. 15, 2 этаж'
            //     },
            //     {
            //         name: 'ГК Мир Упаковки',
            //         tel: '+7 (4942) 440-888',
            //         email: 'mail@mirupakovki.com',
            //         website: 'mirupakovki.com',
            //         address: '156009, г. Кострома, ул. Юбилейная, д. 24'
            //     },
            // ]
        }
    }
}
</script>

<style lang="scss">
.v-expansion-panel-header {
  width: max-content;

  & .distribut__small-title {
    margin-right: 20px;
  }
}
</style>